// Upload card to allow drag-and-drop and file picker image upload

// Import react elements
import React, { useRef } from 'react';

// Import components
import CreateButton from "global/components/CreateButton";
import LoadingDotsAnimation from "global/components/loading_ui/LoadingDotsAnimation";


// Import css
//import './UploadCard.css';



// UploadCard component
const UploadCard = ({ addImages, isLoadingWhileAddingImages, setSelectedImages }) => {


    // Ref to track drag and drop input
    const inputRef = useRef();



    // Handle file/s drop
    const handleDragAndDrop = (event) => {

        // Prevent default behaviour
        event.preventDefault();

        // Extract the files from the drag-and-drop event into a usable array
        const files = Array.from(event.dataTransfer.files);

        // Run uploadsFiles function and pass it the files
        uploadFiles(files);

    };



    // Handle file/s picker
    const handleFileChange = (e) => {

        // Extract the files from the file picker event into a usable array
        const files = Array.from(e.target.files);

        // Run uploadsFiles function and pass it the files
        uploadFiles(files);

    };



    // Trigger the file input manually (useful when users click a custom "Browse" button instead of the native input)
    const openFilePicker = () => {

        // The input is hidden so simulate a click event on it
        inputRef.current.click();

    };



    // Extract data and call upload handler
    const uploadFiles = (files) => {

        // Clear current image/s selection
        setSelectedImages([]); 

        // Set the images to upload
        const imagesToUpload =

            // Map through the files
            files.map(file => ({

                // Set the name as the filename (cleaned up)
                name: file.name.split('.').slice(0, -1).join('.'),

                file

        }));

        // Run function to add images with the imagesToUpload
        addImages(imagesToUpload);

    };



    return (

        <div
            className="upload-card"
            onDrop={handleDragAndDrop}
            onDragOver={(e) => e.preventDefault()}
        >

            {/* If it's loading while adding new images then show loading message until it's finished */}
            {isLoadingWhileAddingImages ?

                <>Loading<LoadingDotsAnimation /></>

                :

                <>

                    <p>Drag images here</p>

                    <br />

                    <CreateButton title="Browse" size="s" onClick={openFilePicker} />

                    <input
                        type="file"
                        accept="image/*"
                        multiple
                        hidden
                        ref={inputRef}
                        onChange={handleFileChange}
                    />

                </>

            }
              
        </div>

    );

};

export default UploadCard;
